import { bool } from "prop-types";
import React from "react";
import { useParams } from "react-router-dom";
import { getBoolAction } from "util/creditBills";
import ActionFCEMTransactionPage from "./BillActions/TransactionPage";
import CreditBillsTransactionPage from "./InformModifyCbu/TransactionPage";
import TransmitFCEMTransactionPage from "./Transmit/TransactionPage";

const TransactionIndex = ({ isDesktop }) => {
    const { action } = useParams();
    const { isTransmission, isInformCbu } = getBoolAction(action);

    if (isTransmission) {
        return <TransmitFCEMTransactionPage isDesktop={isDesktop} />;
    }

    if (isInformCbu) {
        return <CreditBillsTransactionPage isDesktop={isDesktop} />;
    }

    return <ActionFCEMTransactionPage isDesktop={isDesktop} />;
};

TransactionIndex.propTypes = {
    isDesktop: bool.isRequired,
};

export default TransactionIndex;
